// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 451 ? "1edf0483" : chunkId) + "." + {"273":"0985e5f472c2d957","451":"9dfe51f2fe978bc8","651":"6b0a0a214e3e799c","741":"a83780b663de33f6"}[chunkId] + ".js";
};